import React, { useContext, useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CKEditor } from 'ckeditor4-react';
import { makeStyles, useTheme } from '@mui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { UserContext } from '../../common/UserContext';
import RouteConstants from "../../common/RouteConstants";
import SnackbarMsg from "../../sharedComponents/Snackbar/Snackbar";
import adminService from "../../services/admin.service";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import './addEditMemo.css';
import { darkenColor } from '../../utils/appHelper';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    memoContent: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
        flex: 1,
        overflow: 'auto',
        height: 'auto',
        padding: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        }
    },
    formControl: {
        width: '100%',
        margin: 0,
        display: 'flex',
        wrap: 'nowrap'
    },
    content: {
        // margin: theme.spacing(4),
    },

    backdrop: {
        zIndex: theme.zIndex.drawer + 150,
        color: '#fff',
    },
    appBar: {
        top: 'auto',
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: '1250',
        width: '100%',
        // maxWidth: '1440px',
        backgroundColor: theme.palette.background.paper + ' !important',
    },
}));

function AddEditmemo(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const context = useContext(UserContext);
    let params = useParams();
    const [memoTitle, setmemoTitle] = useState('')
    const [editorHTML, setEditorHTML] = useState(null);
    const [errorTitle, setErrorTitle] = useState(false)
    const [currentmemo, setCurrentMemo] = useState({
    });
    const [showError, setShowError] = useState(false);
    const [severity, setSeverity] = useState("");
    const [message, setMessage] = useState("");
    const theme = useTheme();
    useEffect(() => {
        GetMemoById();
    }, [params.id, context]);


    const GetMemoById = () => {
        var memoId = params.id;
        if (memoId && memoId !== "0") {
            adminService.getMemo(memoId)
                .then(memoDetail => {
                    if (memoDetail) {
                        //  let memoDetail = result;
                        setmemoTitle(memoDetail.Title);
                        setTimeout(() => {
                            setEditorHTML(memoDetail.Content);
                        }, 400);

                        setCurrentMemo({ memoDetail });
                    }
                })
        }
    }

    function showAlert(sever, msg) {
        setShowError(true);
        setSeverity(sever)
        setMessage(msg);

    }
    const handleClose = () => {
        setShowError(false);
        setSeverity("")
        setMessage("");
    }

    const redirectToMemos = () => {
        navigate(RouteConstants.ADMIN_MEMO, { state: {} });
    }
    const handleInputChange = (e) => {
        if (e.target.id == "Title") {
            var title = e.target.value;
            if (title == null || title.trim().length == 0)
                setErrorTitle(true);
            else setErrorTitle(false);
            setmemoTitle(title);
        }
    }
    const saveUpdateMemo = () => {
        let getEditorHTML = editorHTML;
        if (memoTitle == null || memoTitle.trim().length == 0) {
            setErrorTitle(true);
            showAlert("error", 'Please enter Title');
        }
        else if (getEditorHTML == null || getEditorHTML.trim().length == 0) {
            showAlert("error", 'Please enter Content');
        }
        else {
            var memo = currentmemo.memoDetail ? currentmemo.memoDetail : new Object();
            memo.Title = memoTitle.trim();
            memo.Content = getEditorHTML;

            //setCurrentMemo(memo);
            adminService.saveMemo(memo)
                .then(data => {
                    if (!data) {
                        showAlert("error", "Memo already exists.");
                    }
                    else if (typeof data == "string") {
                        showAlert("error", data);
                    }
                    else {
                        if (memo.Id)
                            showAlert("success", 'Memo updated successfully.');
                        else
                            showAlert("success", 'Memo created successfully.');
                        setTimeout(() => {
                            redirectToMemos();
                        }, 500);
                    }
                })
                .catch((err) => {
                    showAlert("error", 'Error occured while saving.');
                });
        }
    }

    return (
        <>
            <div className={classes.memoContent}>
                <Grid container direction="row" spacing={2} alignItems="center" className={classes.content}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <TextField
                            required
                            id="Title"
                            label="Title"
                            value={memoTitle}
                            variant="outlined"
                            fullWidth
                            size="small"
                            onChange={(e) => handleInputChange(e)}
                            error={errorTitle}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        {(!params.id || params.id === "0" || editorHTML !== null) && (
                        <CKEditor
                            key={`${theme.palette.mode}-${params.id || 'new'}`} // forces re-mount when light/dark mode changes or when loaded
                            initData={editorHTML || ''}
                            onChange={(event) => setEditorHTML(event.editor.getData())}
                            config={{
                                contentsCss: `body { background-color: ${theme.palette.background.paper}; color: ${theme.palette.text.primary}; }`, // Set background color here  
                                on: {
                                    instanceReady: function () {
                                        // This is where we apply inline CSS to the toolbar once the editor is ready
                                        const toolbar = this.container.$.querySelector('.cke_top'); // Target the toolbar
                                        if (toolbar) {
                                            toolbar.style.backgroundColor = darkenColor(theme.palette.background.default, 5); // Set the toolbar background color
                                            toolbar.style.color = theme.palette.text.primary; // Set the text color
                                        }
                                        const footer = this.container.$.querySelector('.cke_bottom'); // Target the toolbar
                                        if (footer) {
                                            footer.style.backgroundColor = darkenColor(theme.palette.background.default, 5); // Set the toolbar background color
                                            footer.style.color = theme.palette.text.primary; // Set the text color
                                        }
                                    }
                                }
                            }}

                        />
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <Box>
                            <Toolbar></Toolbar>
                            <AppBar position="fixed" color="primary" className={classes.appBar}>
                                <Toolbar>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                                        <Button
                                            id='btnCreatePlaylist'
                                            variant="contained"
                                            style={{ backgroundColor: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main, color: '#ffffff' }}
                                            onClick={saveUpdateMemo}>
                                            {params.id ? 'Update' : 'Save'}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            style={{ marginLeft: '16px', backgroundColor: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main, color: '#ffffff' }}
                                            onClick={redirectToMemos}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Toolbar>
                            </AppBar>
                        </Box>
                    </Grid>
                </Grid>
            </div>

            <SnackbarMsg showError={showError} onClose={handleClose} severity={severity} msg={message} />
        </>
    )
}

export default AddEditmemo;
